import { render, staticRenderFns } from "./batchBidAmountModal.vue?vue&type=template&id=2a034088&scoped=true"
import script from "./batchBidAmountModal.vue?vue&type=script&lang=js"
export * from "./batchBidAmountModal.vue?vue&type=script&lang=js"
import style0 from "./batchBidAmountModal.vue?vue&type=style&index=0&id=2a034088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a034088",
  null
  
)

export default component.exports